// @ts-nocheck
import Page, { IPageAttrs } from 'flarum/common/components/Page';
// @ts-ignore
import IndexPage from 'flarum/components/IndexPage';
import Mithril from 'mithril';
import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import listItems from 'flarum/common/helpers/listItems';
import SingleTopRatedUser from '../SingleTopRatedUser';

export default class ReputationUsers extends Page {
  top20Users: User[] = [];

  oninit(vnode: Mithril.Vnode<IPageAttrs, this>) {
    super.oninit(vnode);
    this.loadTop20Users();
  }

  async loadTop20Users(): Promise<void> {
    try {
      const response: unknown = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/reputation/top',
      });
      // @ts-ignore
      const users = app.store.pushPayload(response);
      this.top20Users = users.filter((model) => model instanceof User) as User[];
      m.redraw();
    } catch (error) {
      console.error('Failed to load users:', error);
    }
  }

  view(vnode: Mithril.Vnode<IPageAttrs, this>): Mithril.Children {
    return (
      <div className="IndexPage">
        {IndexPage.prototype.hero()}
        <div className="container">
          <div className="sideNavContainer">
            <nav className="IndexPage-nav sideNav">
              <ul>{listItems(IndexPage.prototype.sidebarItems().toArray())}</ul>
            </nav>
            <div className="IndexPage-results sideNavOffset">
              <h1 className="glostitle">{app.translator.trans('justoverclock-reputation-score.forum.pageTitle')}</h1>
              <div className="containDef">
                {this.top20Users.map((user: User) => {
                  const userInitial: string = user.displayName().charAt(0);
                  return (
                    <SingleTopRatedUser
                      userLink={`${app.route.user(user)}`}
                      avatarUrl={user.avatarUrl() ?? `https://placehold.co/36x36?text=${userInitial}`}
                      username={user.username()}
                      reputation={user.reputation()}
                      discussionCount={user.discussionCount()}
                      commentCount={user.commentCount()}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
